const LanguageCode = "ta";
document.body.classList.add(LanguageCode + "-body");
const Globals = {
  LanguageCode: "ta",
  language_based_api:
    "https://ws-n.webdunia.com/json/page?lang=" + LanguageCode + "&url=",
  Desktop_language_based_api:
    " " +
    LanguageCode +
    "&menuType=NavigationMenu&menuId=7",
  Desktop_header_based_api:
    "https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=" +
    LanguageCode +
    "&menuType=NavigationMenu&menuId=7",
  Desktop_footer_based_api:
    "https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=" +
    LanguageCode +
    "&menuType=FooterMenu&menuId=7",
  Cricket_update_api: "https://api-en.webdunia.com/getticker",

  Cricket_Scorecard: "http://api.webdunia.com/scorecardJson?MatchId=&LangId=1&InningId=",
  poll_api: "http://m-tamil.webdunia.com/Api/submitpoll",
  Ad_api: "/ads.json",
  AdConfig: "/ads.json",
  Rightbar_api: `https://ws-n.webdunia.com/json/rightbar?lang=${LanguageCode}&url=`,
  //Rightbar_api:"https://m-hindidev.webdunia.com/ad-config/rightbar-test.json",
  common_contents: `https://api-en.webdunia.com/api/v3/app-common-content?lang=${LanguageCode}`,
  DomainUrl: "http://tamil.webdunia.com",
  mobileDomainUrl: "http://m-tamil.webdunia.com",
  FeatureMobileDomainUrl: "http://p-tamil.webdunia.com",
  submit_poll_api: `https://ws-n.webdunia.com/json/api-poll/submit-poll-desktop?lang=${LanguageCode}`,
  videos_api: `https://ws-n.webdunia.com/json/dailymotion/get-video-detail?lang=${LanguageCode}&vid=`
};
export default Globals;
